export default "__VITE_ASSET__8706c486__"